@if (isOpen() && definition(); as def) {
  <div class="help-overlay" role="dialog" aria-modal="true">
    <div class="help-modal" [class.help-modal--guide]="hasGuide()" (click)="$event.stopPropagation()">
      <header class="help-modal-header">
        <div class="help-modal-title-wrap">
          <span class="help-modal-icon" appFeather="help-circle" size="20"></span>
          <h2 class="help-modal-title">{{ t(def.titleKey) }}</h2>
        </div>
        <button type="button" class="help-modal-close" (click)="close()" [attr.aria-label]="t('close')">
          <span appFeather="x" size="18"></span>
        </button>
      </header>

      <div class="help-modal-body">
        @switch (topic()) {
          @case ('ledgerCustomerList') {
            <app-customer-list-help-guide />
          }
          @case ('ledgerChat') {
            <app-chat-screen-help-guide />
          }
          @case ('dashboard') {
            <app-dashboard-help-guide />
          }
          @case ('settings') {
            <app-settings-help-guide />
          }
          @case ('followupList') {
            <app-followup-list-help-guide />
          }
          @case ('recurringFollowupList') {
            <app-recurring-followup-list-help-guide />
          }
          @case ('recycleBin') {
            <app-recycle-bin-help-guide />
          }
          @case ('pendingTransactions') {
            <app-pending-transactions-help-guide />
          }
          @case ('customerStatement') {
            <app-customer-statement-help-guide />
          }
          @case ('commonStatement') {
            <app-common-statement-help-guide />
          }
          @case ('userProfile') {
            <app-user-profile-help-guide />
          }
          @case ('customerProfile') {
            <app-customer-profile-help-guide />
          }
          @case ('addCustomer') {
            <app-add-customer-help-guide />
          }
          @case ('transferGroup') {
            <app-transfer-group-help-guide />
          }
          @case ('pendingTransactionsDialog') {
            <app-pending-transactions-dialog-help-guide />
          }
          @case ('entryCreate') {
            <app-entry-create-help-guide />
          }
          @case ('entryEdit') {
            <app-entry-edit-help-guide />
          }
          @case ('entryFollowUp') {
            <app-entry-followup-help-guide />
          }
          @case ('entryRecurringPayment') {
            <app-entry-recurring-payment-help-guide />
          }
          @case ('followupDialog') {
            <app-followup-dialog-help-guide />
          }
          @case ('recurringFollowupDialog') {
            <app-recurring-followup-dialog-help-guide />
          }
          @case ('aiVoice') {
            <app-ai-voice-help-guide />
          }
          @case ('aiChat') {
            <app-ai-chat-help-guide />
          }
          @case ('businessPopup') {
            <app-business-popup-help-guide />
          }
          @default {
            <div class="help-guide">
              <section class="help-guide-card">
                <header class="help-guide-section-head">
                  <span class="help-guide-section-icon" appFeather="info" size="18"></span>
                  <div>
                    <h3 class="help-guide-section-title">{{ t('help') }}</h3>
                    <p class="help-guide-section-desc">{{ t(def.introKey) }}</p>
                  </div>
                </header>
              </section>

              <section class="help-guide-card">
                <header class="help-guide-section-head">
                  <span class="help-guide-section-icon" appFeather="grid" size="18"></span>
                  <div>
                    <h3 class="help-guide-section-title">{{ t('helpIconsSection') }}</h3>
                    <p class="help-guide-section-desc">{{ t('helpIconsSectionDesc') }}</p>
                  </div>
                </header>

                <ul class="help-guide-icon-list">
                  @for (item of def.icons; track item.icon) {
                    <li class="help-guide-icon-item">
                      <span class="help-guide-icon-badge" [attr.aria-hidden]="true">
                        <span [appFeather]="item.icon" size="18"></span>
                      </span>
                      <div class="help-guide-icon-text">
                        <p class="help-guide-icon-title">{{ t(item.titleKey) }}</p>
                        <p class="help-guide-icon-desc">{{ t(item.descKey) }}</p>
                      </div>
                    </li>
                  }
                </ul>

                @if (def.extraKey) {
                  <div class="help-guide-tip">{{ t(def.extraKey) }}</div>
                }
              </section>
            </div>
          }
        }
      </div>

      <footer class="help-modal-footer">
        <button type="button" class="help-ok-btn" (click)="close()">{{ t('close') }}</button>
      </footer>
    </div>
  </div>
}
